<template>
	<div class="select-list">
		<ul class="select-list__tab">
			<li
				v-for="(tab, index) in tabList"
				:key="index"
				:class="[
					'select-list__tab-item',
					{
						'select-list__tab-item--selected': currentTab === tab,
						'select-list__tab-size': type === 'large',
					},
				]"
				@click="selectItem(tab)"
			>
				{{ tab }}
			</li>
		</ul>
	</div>
</template>
<script>
	export default {
		name: 'SelectListTab',
		components: {},
		data() {
			return {
				currentTab: this.value,
			};
		},
		props: {
			tabList: {
				type: Array,
				default: [],
			},
			value: {
				type: String,
				default: '',
			},
			type: {
				type: String,
				default: '',
			},
		},
		computed: {},
		methods: {
			selectItem(tab) {
				this.currentTab = tab;
				this.$emit('input', this.currentTab);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.select-list {
		.select-list__tab {
			display: flex;
			align-items: center;
		}

		.select-list__tab-item {
			font-size: 14px;
			margin-top: 20px;
			padding: 0 20px 4px;
			color: #9b9b9b;
			cursor: pointer;
			&.select-list__tab-item--selected {
				color: #1976d1;
				border-bottom: 2px solid #1976d1;
				transition: all ease 0.1s;
				&.select-list__tab-size {
					font-size: 20px;
				}
			}
		}
	}
</style>
